import React, { useState, useEffect } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import axios from "axios";
// import InputWithLabel from "../Inputs/InputWithLabel";
// import Label from "../Misc/Label";
// import CustomCheckbox from "../components/Inputs/CustomCheckbox";
// import InputWithLabel from "../components/Inputs/InputWithLabel";
// import Label from "../components/Misc/Label";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { validName } from "./Validations";

import CustomCheckbox from "../Inputs/CustomCheckbox";
import InputWithLabel from "../Inputs/InputWithLabel";
import Label from "../Misc/Label";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { addKol } from "../../redux/actions/web3Actions";

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    // padding: theme.spacing(10, 18),
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  stepHeader: {
    marginBottom: "3rem",
  },
  btn: {
    fontWeight: "600",
    width: "16rem",
    fontSize: "1.4rem",
  },
}));

const KolRegistrationStepOne = ({
  onNextClick,
  changeFlag,
  setDisableButton,
  formErrors,
  setFormErrors,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const web3context = useWeb3React();

  const [name, setName] = useState("");

  const [walletAddress, setWalletAddress] = useState(
    web3context?.account || ""
  );
  const history = useHistory();

  const [twitterFollower, setTwitterFollower] = useState("");
  const [youtubeSubscriber, setYoutubeSubscriber] = useState("");
  const [tiktokFollower, setTiktokFollower] = useState("");
  const [instaFollower, setInstaFollower] = useState("");

  const [twitterHandle, setTwitterHandle] = useState("");
  const [youtubeHandler, setYoutubeHandler] = useState("");
  const [tiktokHandler, setTiktokHandler] = useState("");
  const [instaHandler, setInstaHandler] = useState("");

  const callbackFunction = (kolId) => {
    if (kolId) {
      axios
        .delete(`https://protokol-server.herokuapp.com/kol/${kolId}`)
        .then(() => true);
    }
    history.push("/dashboard");
  };
  const [checkBoxes, setCheckBoxes] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
  });

  useEffect(() => {
    if (name && walletAddress && twitterHandle) setDisableButton(false);
  }, [name, walletAddress, twitterHandle]);

  useEffect(() => {
    console.log("flag clicked 1", changeFlag);
    if (web3context.account) {
      setWalletAddress(web3context?.account);
    }

    // console.log("regex", validHandle.test("@JohnDoe"));

    if (changeFlag == 1) {
      console.log("AFTER REGEX", name);

      if (formErrors.errorHandle == "") {
        dispatch(
          addKol(
            {
              name,
              walletAddress,
              handlers: [
                twitterHandle,
                youtubeHandler,
                tiktokHandler,
                instaHandler,
              ],
              followers: [
                twitterFollower,
                youtubeSubscriber,
                tiktokFollower,
                instaFollower,
              ],
            },
            callbackFunction
          )
        );
      }
    }
  }, [changeFlag, web3context]);

  return (
    <Box className={classes.container}>
      <Box>
        <InputWithLabel
          label="Name"
          value={name || ""}
          setValue={setName}
          placeholder="John Doe"
          width={550}
        />

        <InputWithLabel
          label="Wallet Address"
          value={web3context?.account}
          setValue={setWalletAddress}
          placeholder="0x1e...efd2"
          width={550}
        />

        <Box marginBottom="2.4rem">
          <Label label="Social Media Platforms" />
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" flexDirection="column">
              <CustomCheckbox
                label="Twitter"
                checked={checkBoxes[1]}
                handleChange={() =>
                  setCheckBoxes({
                    ...checkBoxes,
                    1: !checkBoxes[1],
                  })
                }
              />

              {checkBoxes[1] && (
                <InputWithLabel
                  label="Follower Count"
                  placeholder="10"
                  value={twitterFollower}
                  setValue={setTwitterFollower}
                  marginRight={38}
                  type={"number"}
                />
              )}

              {checkBoxes[1] && (
                <InputWithLabel
                  label="Handle"
                  placeholder="@JohnDoe"
                  value={twitterHandle}
                  setValue={setTwitterHandle}
                  marginRight={38}
                  handle
                  error={formErrors.errorHandle}
                  setFormErrors={setFormErrors}
                />
              )}
            </Box>

            <Box display="flex" flexDirection="column">
              <CustomCheckbox
                disable
                label="Youtube"
                checked={checkBoxes[2]}
                handleChange={() =>
                  setCheckBoxes({
                    ...checkBoxes,
                    2: !checkBoxes[2],
                  })
                }
              />

              {checkBoxes[2] && (
                <InputWithLabel
                  label="Subscriber Count"
                  placeholder="10"
                  value={youtubeSubscriber}
                  setValue={setYoutubeSubscriber}
                  marginRight={38}
                  type={"number"}
                />
              )}

              {checkBoxes[2] && (
                <InputWithLabel
                  label="Subscriber Count"
                  placeholder="10"
                  value={youtubeSubscriber}
                  setValue={setYoutubeSubscriber}
                  marginRight={38}
                  type={"number"}
                />
              )}
            </Box>

            <Box display="flex" flexDirection="column">
              <CustomCheckbox
                label="TikTok"
                disable
                // checked={checkBoxes[3]}
                checked={false}
                handleChange={() =>
                  setCheckBoxes({
                    ...checkBoxes,
                    3: !checkBoxes[3],
                  })
                }
              />

              {checkBoxes[3] && (
                <InputWithLabel
                  label="Follower Count"
                  placeholder="10"
                  value={tiktokFollower}
                  setValue={setTiktokFollower}
                  marginRight={38}
                  type={"number"}
                />
              )}

              {checkBoxes[3] && (
                <InputWithLabel
                  label="Handle"
                  placeholder="@JohnDoe"
                  marginRight={38}
                  value={tiktokHandler}
                  setValue={setTiktokHandler}
                />
              )}
            </Box>

            <Box>
              <CustomCheckbox
                label="Instagram"
                disable
                checked={false}
                handleChange={() =>
                  setCheckBoxes({
                    ...checkBoxes,
                    4: !checkBoxes[4],
                  })
                }
              />

              {/* {checkBoxes[4] && (
                <InputWithLabel
                  label="Subscriber Count"
                  placeholder="10K"
                  value={instaFollower}
                  setValue={setInstaFollower}
                  type={"number"}
                />
              )}

              {checkBoxes[4] && (
                <InputWithLabel
                  label="Handle"
                  placeholder="JohnDoe"
                  value={instaHandler}
                  setValue={setInstaHandler}
                  // marginRight={38}
                />
              )} */}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default KolRegistrationStepOne;
